import { gql } from "@apollo/client";

export const FORGOT_PASSWORD = gql`
query ForgotPassword ($emailId: String!) {
  forgotPassword(emailId: $emailId) {
    message
  }
}
`;
